import Alert from "@material-ui/lab/Alert";
import React, { useEffect } from "react";
import { useDataProvider, useRecordContext } from "react-admin";

const AdhocOperatorInfo = () => {
  const record = useRecordContext();
  const provider = useDataProvider();

  const [drivers, setDrivers] = React.useState<IDriver[]>([]);
  const [busAssistants, setBusAssistants] = React.useState<IDriver[]>([]);
  const [subcontractors, setSubcontractors] = React.useState<ISubcontractor[]>(
    [],
  );

  const getDrivers = async () => {
    const { data: drivers } = await provider.getMany("drivers", {
      ids: [record.driverId, record.replacedDriverIdByAdhocOperator],
    });
    setDrivers(drivers as IDriver[]);
  };

  const getBusAssistants = async () => {
    const { data: busAssistants } = await provider.getMany("busAssistants", {
      ids: [
        record.busAssistantId,
        record.replacedBusAssistantIdByAdhocOperator,
      ],
    });
    setBusAssistants(busAssistants as IDriver[]);
  };

  const getSubcontractors = async () => {
    const { data: subcontractors } = await provider.getMany("subcontractors", {
      ids: [record.adhocSubcontractorId],
    });
    setSubcontractors(subcontractors as ISubcontractor[]);
  };

  const getDriverName = (drivers: IDriver[], driverId: number) => {
    return drivers.find((driver: IDriver) => driver.id === driverId)?.fullName;
  };

  const getBusAssistantName = (
    busAssistants: IDriver[],
    busAssistantId: number,
  ) => {
    return busAssistants.find(
      (busAssistant: IDriver) => busAssistant.id === busAssistantId,
    )?.fullName;
  };

  const getSubcontractorName = (
    subcontractors: ISubcontractor[],
    subcontractorId: number,
  ) => {
    return subcontractors.find(
      (subcontractor: ISubcontractor) => subcontractor.id === subcontractorId,
    )?.name;
  };

  useEffect(() => {
    if (record.replacedDriverIdByAdhocOperator) {
      getDrivers();
    }

    if (record.replacedBusAssistantIdByAdhocOperator) {
      getBusAssistants();
    }

    if (record.adhocSubcontractorId) {
      getSubcontractors();
    }
  }, [record]);

  if (
    !record.replacedDriverIdByAAdhocOperator &&
    !record.replacedBusAssistantIdByAAdhocOperator &&
    !record.adhocSubcontractorId
  ) {
    return <></>;
  }

  return (
    <Alert severity="info">
      {record.replacedDriverIdByAdhocOperator && (
        <>
          <strong>
            Driver [
            {getDriverName(drivers, record.replacedDriverIdByAdhocOperator)}]
          </strong>{" "}
          has been replaced by{" "}
          <strong>
            Adhoc Driver [{getDriverName(drivers, record.driverId)}]
          </strong>
          {record.replacedBusAssistantIdByAdhocOperator && <br />}
        </>
      )}
      {record.replacedBusAssistantIdByAdhocOperator && (
        <>
          <strong>
            Bus Assistant [
            {getBusAssistantName(
              busAssistants,
              record.replacedBusAssistantIdByAdhocOperator,
            )}
          </strong>
          ] has been replaced by{" "}
          <strong>
            Adhoc Bus Assistant [
            {getBusAssistantName(busAssistants, record.busAssistantId)}]
          </strong>
        </>
      )}
      {record.adhocSubcontractorId && (
        <>
          <br />
          <strong>Subcontractor</strong> was using{" "}
          <strong>
            Adhoc Subcontractor [
            {getSubcontractorName(subcontractors, record.adhocSubcontractorId)}]
          </strong>
        </>
      )}
    </Alert>
  );
};

export default AdhocOperatorInfo;
